import Vue from 'vue/dist/vue.runtime.esm';
// import XCodes from '@ul/xerror/codes';
// import messages from '@ul/xerror/messages.esm';
import fields from "../libs/fields";
//产品级配置
const config = {
    APPID: 'JSZC',
    APP_TITLE:fields.title,
    BASE: 'http://192.168.10.88:9540/',
    APIBASE: 'http://192.168.10.202:9710',
    // PLATFORM: '/staq/web/index.html',
    GET_USERINFO_URL: '/auth/mLogin',
    GET_TEACHERINFO_URL: '/auth/nLogin',
};
document.title='[四川]'+config.APP_TITLE
config.token = '0ABCGE2YBG7A9F;xSrjzEdYxtLrWZzJ2VMZj5-WoN_rvMSI1vK0qa_9eQu-DUwBeE1jPsXYZqiNQ8q6W5b1u2cengM_dGH_nrhJqtvrcNUZH7fgYJBoe3gzg6qFt-U6QEAGF8M-yPQoXhc-kuW_9vDDIKvogab0gdP9UuqJrLfLmPWyX4FZVbidAjVavY9c2pZ3M87YysrSd2W8HLP-8PzPquJZBaqpqgAUrYFJoJK7a0l4qmUyEahn9MGbEwYyCjJe0EOQn7CmUVbGQZORRPADc_rZ_cy3CH71c3JR_0wX8yBSlolDH4gT3_reJ1BeCpZIvskbofxjsKpQPeBPdM3dqvgoSowo1azxuYwo2G2rlLCKyWHPe0sU0MmBV30GHiCCvApG6jbMZ7pjqHT0kitYN3qWDhlG2oRhsGoEflm4VvYFRKesPoDPRk_xzIEC6_lndBeT9y33E97oGB_b7v0k1fkwin285Ma6dANi3buxQYfnquMsB7sDtcTu2jFToR6xA6sYlihzwg==;MEQCIGwguEODyAhTHN13jJ_WufxdDDQ1HwNjl1FsjWZlquBUAiBQAorb7sCP9zhoprqVVtJa2deHGmQlpmVHCUMJHmhGlQ==';//成都
//开发配置






//注册配置;
Vue.prototype.$CONFIG = config;
export default config;
// Vue.prototype.$XCODES = XCodes;
// Vue.prototype.$MESSAGE = messages;


